var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SharePageTemplate',{scopedSlots:_vm._u([{key:"image-content",fn:function(){return [_c('ImageCompareArea',{attrs:{"sliderLineWidth":2,"leftImage":_vm.$route.query.start,"rightImage":_vm.$route.query.end,"switch":false}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }